import { DiscoveryApi, FetchApi } from "@backstage/core-plugin-api";
import { GenAIApimOperations, Subscription, NewSubscription, LiteLLMKeyInfo } from "../types";
import { HttpError } from "../shared/errors/HttpError";

export class GenAIBackendClient implements GenAIApimOperations {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;
  constructor(
    options: {discoveryApi: DiscoveryApi; fetchApi: FetchApi}
  ) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async getGenAI_APIMSubscriptions(): Promise<Subscription[]> {
    const url = await this.discoveryApi.getBaseUrl('genai-platform');
    const response = await this.fetchApi.fetch(`${url}/apimsubscription`, {
      method: 'GET',
    });
    if (!response.ok) {
      throw new Error(`Failed to load subscriptions: ${response.status}`);
    }
    return await response.json();
  }

  async createGenAI_APIMSubscriptions(): Promise<NewSubscription> {
    const url = await this.discoveryApi.getBaseUrl('genai-platform');
    const response = await this.fetchApi.fetch(`${url}/apimsubscription`, {
      method: 'POST',
    });
    if (!response.ok) {
      const errorBody = await response.json();
      const errorMessage = errorBody.error || `Request failed with status ${response.status}`;
      throw new HttpError(errorMessage, response.status);
    }
    return await response.json();
  }

  async regenerateGenAI_APIMSubscriptions(id: string): Promise<void> {
    const url = await this.discoveryApi.getBaseUrl('genai-platform');
    const response = await this.fetchApi.fetch(`${url}/apimsubscription/${id}/regeneratekeys`, {
      method: 'POST',
    });

    if (!response.ok) {
      const errorBody = await response.json();
      const errorMessage = errorBody.message || `Request failed with status ${response.status}`;
      throw new Error(errorMessage);
    }
  }

  async getGenAI_LiteLLMKeyInfo(): Promise<LiteLLMKeyInfo> {
    const url = await this.discoveryApi.getBaseUrl('genai-platform');
    const response = await this.fetchApi.fetch(`${url}/litellm/keyinfo`, {
      method: 'GET',
    });
    if (!response.ok) {
      throw new Error(`Failed to load LiteLLM key info: ${response.status}`);
    }
    return await response.json();
  }
}
